// MARK: React
import * as React from "react";
import { observer, inject } from "mobx-react";
import "./style.scss";

// MARK: Components
import BedroomsTable from "./BedroomsTable";
import BedroomCreateOrEdit from "./BedroomCreateOrEdit";

// MARK: Router
import { Route, Switch } from "react-router-dom";

// MARK: Stores
import AuthStore from "../../../stores/AuthStore";

// MARK: Resources
import strings from "../../../resources/strings";

interface IProps {
	authStore: AuthStore;
}

@inject("authStore")
@observer
export default class Bedrooms extends React.Component<IProps> {
	public componentDidMount = async () => {
		await this.props.authStore.authenticate();
	};

	public render() {
		return (
			<div className="bedrooms">
				<Switch>
					<Route exact={true} path="/dashboard/bedrooms/editor" component={BedroomCreateOrEdit} />
					<Route path="/dashboard/bedrooms/editor/:bedroomId" component={BedroomCreateOrEdit} />
					<Route path="/dashboard/bedrooms" component={BedroomsTable} />
				</Switch>
			</div>
		);
	}
}
